import { useQuery } from '@mint-lib/query-client';
import { Schedule } from '@mint-sdk/api-ai-assistant';

export const useGetScheduledChatDetails = (chatId: string) => {
  const { data: scheduledMsgData = [] } = useQuery({
    ...Schedule.getScheduleOptions({}),
    enabled: !!chatId,
  });

  return scheduledMsgData.find((s) => s.chatSessionId === chatId);
};
